import { MachineToMachineAuthStrategy } from '@frontegg/rest-api';
export { MachineToMachineAuthStrategy };
export let ApiStateKeys;
(function (ApiStateKeys) {
  ApiStateKeys["LOAD_API_TOKENS"] = "LOAD_API_TOKENS";
  ApiStateKeys["ADD_API_TOKEN"] = "ADD_API_TOKEN";
  ApiStateKeys["DELETE_API_TOKEN"] = "DELETE_API_TOKEN";
})(ApiStateKeys || (ApiStateKeys = {}));